<template>
  <pdl-form-group
    v-model="line1"
    :help-text="helpText"
    :maxlength="40"
    name="line1"
    :label="$t('address.line1')"
    :error="getErrorMessage('line1')"
    required
  />
</template>

<script>
import {PdlFormGroup} from '@pedal/pdl-form-group';
import {mapState, mapMutations} from 'vuex';
import {TrekValidationMixin} from '@/utils/validation/trek-validation-mixin';
export default {
  components: {PdlFormGroup},
  mixins: [TrekValidationMixin],
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    isBillingAddressForm: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      ...TrekValidationMixin.setup(),
    };
  },
  validations() {
    return {
      line1: {
        required: this.trekValidators.requiredWithCustomMessage('address.line1.invalid'),
        maxLength: this.trekValidators.maxLength('address.line1', 40),
      },
    };
  },
  computed: {
    ...mapState('checkout', ['billingAddress']),
    line1: {
      get() {
        return this.billingAddress.line1 ? this.billingAddress.line1 : this.modelValue;
      },
      set(line1) {
        this.setLine1(line1);
      },
    },
    fieldName() {
      return 'line1';
    },
    helpText() {
      return this.isBillingAddressForm ? '' : this.$t('text.UPSDelivery');
    },
  },
  methods: {
    ...mapMutations('checkout', ['setLine1']),
  },
};
</script>
